import {ServerApi} from "../../api/ServerApi";
import {sendLog} from "../common/SendLog";

//Подписанные документы
export async function getSignedDocuments(docSessionCode, title, appDebag) {
    const serverApi = new ServerApi();

    //Получать подписанные документы.
    return serverApi.completeProcess(docSessionCode, appDebag).then((response) => {
        sendLog(serverApi, title, 'Получать подписанные документы.', 'getSignedDocuments', false, response);
        if (response.data?.success) {
            const rawDocs = response.data.data;
            const documentsArray = rawDocs ? Object.entries(rawDocs).map(([id, doc]) => ({id, ...doc})) : [];
            localStorage.setItem("signed", JSON.stringify(documentsArray));
            return documentsArray; // Возвращаем готовый массив
        } else {
            return [];
        }
    }).catch((error) => {
        sendLog(serverApi, title, 'Получать подписанные документы.', 'getSignedDocuments', true, error);
        return [];
    });
}
